new Vue({
    el: '#loan',
    data: {
        loanAmount: null,
        fullname: null,
        birthDate: null,
        personalId: null,
        phone: null,
        email: null,
        monthlyIncome: null,


        selectedLoanType: null,
        selectedLoanCurrency: null,
        selectedIncomeType: null,
        selectedOtherIncomeType: null,
        selectedIncomeTypeCurrency: null,
        selectedPin: null,



        loanTypes: [],
        currencies: [],
        incomeTypes: [],
        pins: [],
        intro: null,
        terms: null,

        isSubmited: false,
        result: false,
        resultMessage: null,
        sendingData: false,

        anotherIncomeTypeCheckbox: false,

        agreeTerms: false,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    },
    methods: {
        send: function (e) {
            e.preventDefault();
            var _this = this;
            debugger;
            if (_this.sendingData) { return; }
            _this.resultMessage = null;
            _this.isSubmited = true;
            valid = true;
            if (!_this.selectedLoanType ||
                !_this.selectedPin ||
                !_this.loanAmount ||
                !_this.fullname ||
                !_this.birthDate ||
                !_this.personalId ||
                !_this.phone ||
                !_this.email ||
                !_this.monthlyIncome ||
                !_this.agreeTerms ||
                _this.personalId.length != 11
                || !_this.reg.test(_this.email)) {
                valid = false;
            }
            if (valid) {
                _this.sendingData = true;
                axios.post('~/api/loan/send',
                    {
                        loanType: _this.selectedLoanType['title'],
                        loanAmount: _this.loanAmount,
                        loanCurrency: _this.selectedLoanCurrency['title'],
                        fullname: _this.fullname,
                        birthDate: _this.birthDate,
                        personalId: _this.personalId,
                        phone: _this.phone,
                        email: _this.email,
                        incomeType: _this.anotherIncomeTypeCheckbox ? '' : _this.selectedIncomeType['title'],
                        otherIncomeType: _this.selectedOtherIncomeType,
                        monthlyIncome: _this.monthlyIncome,
                        monthlyIncomeCurrency: _this.selectedIncomeTypeCurrency['title'],
                        branch: _this.selectedPin['title'],
                        captchaVal: $("#g-recaptcha-response").val(),
                        languageId: window.languageId
                    }).then(function (response) {
                        _this.result = response.data.success;
                        _this.resultMessage = response.data.message;
                    }).catch(function (e) {
                        _this.result = false;
                        _this.resultMessage = window.errorPhrase;
                    }).finally(function (e) {
                        _this.sendingData = false;
                    });
            }
            _this.isSubmited = true;

            return false;
        }
    },
    mounted: function () {
        var _this = this;
        if (!!window.loanFormSettings) {
            _this.loanTypes = window.loanFormSettings.loanTypes;
            _this.currencies = window.loanFormSettings.currencies;
            _this.incomeTypes = window.loanFormSettings.incomeTypes;
            _this.pins = window.loanFormSettings.pins;
            _this.intro = window.loanFormSettings.intro;
            _this.terms = window.loanFormSettings.terms;
            _this.selectedLoanCurrency = _this.currencies[0];
            _this.selectedIncomeTypeCurrency = _this.currencies[0];
            //if (!!window.currentLoanId) {
            //    for (var i = 0; i < _this.loanTypes.length; i++) {
            //        console.log(i);
            //        if (_this.loanTypes[i].id == window.currentLoanId) {
            //            _this.selectedLoanType = _this.loanTypes[i];
            //            break;
            //        }
            //    }
            //}
        }
    }
})